export const DEFAULT_LOCALE = 'en'

// prettier-ignore
export const appLocales = [
	'en',
	'es',
]

export default {
	DEFAULT_LOCALE,
	appLocales,
}
